/** Opções de motivo da visita (paridade app mobile + cadastro web). */

export const MOTIVOS_VISITA = [
  { id: "auditoria_qualidade_certificacao", label: "Auditoria, qualidade ou certificação" },
  { id: "cliente_fornecedor_parceiros", label: "Cliente, Fornecedor ou parceiros" },
  { id: "entrega_materiais_coleta", label: "Entrega de materiais ou coleta" },
  { id: "entrevista_candidato", label: "Entrevista de candidato" },
  { id: "orgaos_reguladores_fiscalizacao", label: "Órgãos reguladores / fiscalização" },
  { id: "reuniao_comercial", label: "Reunião comercial" },
  { id: "suporte_tecnico_manutencao", label: "Suporte técnico / manutenção" },
  { id: "treinamento_capacitacao", label: "Treinamento / capacitação" },
  { id: "visita_academica_escola", label: "Visita acadêmica / Escola" },
  { id: "visita_tecnica_operacional", label: "Visita técnica / operacional" },
];

/** Rótulos antigos gravados antes da lista unificada (case-insensitive). */
const LEGACY_MOTIVO_LABEL_TO_ID = {
  "visita academica / escola": "visita_academica_escola",
  "visita acadenica / escola": "visita_academica_escola",
  "reunião comercial / apresentação": "reuniao_comercial",
  "visita técnica ou inspeção": "visita_tecnica_operacional",
  "entrega de materiais ou amostras": "entrega_materiais_coleta",
  "treinamento ou capacitação": "treinamento_capacitacao",
  "negociação de contrato ou parceria": "cliente_fornecedor_parceiros",
  "auditoria ou qualidade": "auditoria_qualidade_certificacao",
};

/**
 * Converte texto vindo da API (`motivo_visita`) no `id` do select.
 * Texto sem correspondência (ex.: antigo "Outro: …") retorna "".
 */
export function parseMotivoVisitaFromStoredText(motivoTexto) {
  const texto = String(motivoTexto || "").trim();
  if (!texto) return "";
  const lower = texto.toLowerCase();
  const op = MOTIVOS_VISITA.find((m) => m.label.toLowerCase() === lower);
  if (op) return op.id;
  const legacyId = LEGACY_MOTIVO_LABEL_TO_ID[lower];
  if (legacyId) return legacyId;
  return "";
}

/** Rótulo enviado em `motivo_visita` na API. */
export function resolveMotivoVisitaParaApi(motivoId) {
  const id = String(motivoId || "").trim();
  if (!id) return "";
  const opt = MOTIVOS_VISITA.find((m) => m.id === id);
  return opt?.label ?? "";
}
